import { IProductionDashboardBayVehicle } from "../models/ProductionDashboard";

/** The progress of one station on one vehicle, as the finished test needs it. */
export interface IStationProgress {
  partsRemoved: number;
  partsTotal: number;
  startedOn: string | null;
  timerFinished: boolean;
}

/**
 * Whether the work at a station is over.
 *
 * With parts, it is every part actioned - removed, missing, damaged or not accessible all count,
 * which is what the API's parts-removed count already reflects - with the timer stopped. With no
 * parts on the vehicle there is nothing to tick off, so the timer decides: finished is done,
 * paused (or never run) is not. Either way a running timer means someone is still working it,
 * however many parts are ticked.
 */
export const isStationFinished = (station: IStationProgress): boolean =>
  !station.startedOn &&
  (station.partsTotal > 0
    ? station.partsRemoved >= station.partsTotal
    : !!station.timerFinished);

/**
 * Whether a vehicle has finished the station it is sitting on and is only waiting to be moved on.
 *
 * A vehicle that has finished its last assembly is done rather than waiting: it drops out of the
 * lanes into Completed Today, so it is excluded here.
 */
export const isAwaitingNextStation = (
  vehicle: Pick<
    IProductionDashboardBayVehicle,
    | "percentComplete"
    | "currentAssemblyPartsRemoved"
    | "currentAssemblyPartsTotal"
    | "currentAssemblyStartedOn"
    | "currentAssemblyTimerFinished"
  >
): boolean =>
  vehicle.percentComplete < 100 &&
  isStationFinished({
    partsRemoved: vehicle.currentAssemblyPartsRemoved,
    partsTotal: vehicle.currentAssemblyPartsTotal,
    startedOn: vehicle.currentAssemblyStartedOn,
    timerFinished: vehicle.currentAssemblyTimerFinished,
  });
